export const appStrings = {
  modules: {
    questionnaire: {
      facet: 'Facet',
    },
    backrsSidebar: {
      backrs: 'backrs',
      search: 'Search',
    },
    comingSoon: {
      title: 'Page Coming Soon',
    },
    desktopOnlyNotice: {
      title: 'Not optimized for mobile',
      description:
        'For the best experience, please take the Life-Readiness Assessment on a browser.',
      copyLink: 'Copy Link',
    },
    notFound404: {
      title: 'Page not Found',
      action: 'Go Home',
    },
    login: {
      dividerText: 'OR',
      phonePlaceholder: 'Enter your phone #',
      emailPlaceholder: 'Enter your email',
      passwordPlaceholder: 'Enter your password',
      forgotPassword: 'Forgot Password?',
      backrsLogoAlt: 'Backrs logo',
      getStartedPrompt: 'Log in or sign up to get started.',
      getStartedButton: 'sign up',
      forgotPasswordPrompt:
        'Please enter your email address and we will send you a link to reset your password.',
      forgotPassowordButton: 'Send',
      forgotPasswordSuccess:
        'If you have an account, you will receive an email to reset your password.',
      error: {
        invalidPhone: 'Please enter a valid phone number',
        invalidEmail: 'Please enter a valid email',
        emailRequired: 'Email is required',
        passwordRequired: 'Password is required',
        phoneEmailRequired: 'Phone number or email is required',
        login: {
          userNameOrPassword: 'Log in failed: Invalid username or password',
          phone: 'Log in failed: Invalid phone number',
          genericError:
            'An error occurred while logging in. Please try again or contact an administrator for assistance.',
        },
      },
      otp: {
        title: 'Check your text messages',
        sentCodeTo: 'We sent a verification code to',
        didntReceiveText: 'Didn’t receive the text?',
        clickToResend: 'Click to resend',
        logIn: 'Log In',
        resendCode: 'Enter your phone number to resend your verification code.',
        contactSupportPrompt: 'Still not working? ',
        contactSupportButton: 'Contact support.',
        backToLogin: 'Back to log in',
        verifyPhoneNumber: 'Verify phone number',
      },
      welcomeBack: 'Welcome back! Please enter your details.',
      dontHaveAccount: "Don't have an account?",
      signUp: 'Sign up',
    },
    register: {
      title: 'Join the community',
      confirmAge: 'I certify that I am 14 years of age or older.',
      termsPrompt: 'By registering, I accept Backrs Terms & Conditions',
      termsButton: 'Backrs Terms & Conditions',
      firstNamePlaceholder: 'First Name',
      lastNamePlaceholder: 'Last Name',
      phonePlaceholder: 'Phone Number',
      emailPlaceholder: 'Email',
      passwordPlaceholder: 'Password',
      inviteCodePlaceholder: 'Invite Code (if applicable)',
      buttonLabel: 'Save & Continue',
      ageCertification: 'I certify that I am 14 years of age or older.',
      error: {
        invalidPhone: 'Please enter a valid phone number',
        invalidEmail: 'Please enter a valid email',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        emailRequired: 'Email is required',
        phoneRequired: 'Phone number is required',
        passwordRequired: 'Password is required',
        login: {
          userNameOrPassword: 'Log in failed: Invalid username or password',
          phone: 'Log in failed: Invalid phone number',
          genericError:
            'An error occurred while logging in. Please try again or contact an administrator for assistance.',
        },
      },
    },
    charts: {
      returnOnInvestment: {
        average: 'Average',
        title: '14-Year Estimated Return on Investment',
        explanationTitle: 'ROI Levels: How Worthwhile Is the Investment?',
        explanationText: {
          first:
            "Going to college or getting more education after high school is different from investing in something like the stock market. Instead of putting money into a company or business, you're investing in yourself. The return you get depends on the choices you make—like which school you attend, what you study, and how well you perform (such as your GPA).\n\nYour ",
          second: 'Return On Investment',
          third:
            " (ROI) helps you estimate what you'll get back from the time, effort, and money you put into college—and how soon it will pay off. Studies show that what you study matters more for your future earnings than where you go. A strong ROI can help you become financially independent sooner—that means earning enough to support yourself without help. It also puts you in a better position to start building wealth, like saving or investing for the future.",
        },

        modalCards: {
          veryGoodROI: {
            title: 'Very Good ROI',
            chipLabel: '100% or higher',
            chipColor: 'Success/500',
            iconName: 'Hurricane01',
            cardDescription: [
              {
                text: 'Your investment ',
                bold: false,
              },
              {
                text: 'doubled or more.',
                bold: true,
              },
              {
                text: ' You earned back every dollar you spent—and then earned at least that much extra. You’re in a strong financial position and may have reached payback in just a few years.',
                bold: false,
              },
            ],
            leftCardContent: {
              title: 'Example:',
              description: [
                {
                  text: '100% ROI means if you invested $100, you’d end up with $200 after 14 years—your initial $100 investment, plus an extra $100 in earned income.',
                  bold: false,
                },
              ],
            },
            rightCardContent: {
              title: 'Why it matters:',
              description: [
                {
                  text: 'This kind of ROI opens doors. You might start investing, saving for a home, or building wealth sooner. It’s common in high-paying majors like engineering or computer science—or when students keep costs low through scholarships or in-state tuition.',
                  bold: false,
                },
              ],
            },
          },
          goodROI: {
            title: 'Good ROI',
            chipLabel: '0% to 99%',
            chipColor: 'Warning/500',
            iconName: 'Hurricane04',
            cardDescription: [
              {
                text: 'You still came out ahead, but the gain was smaller. You earned back more than you spent, but it may take longer to fully realize the payoff. Choosing a major with strong job prospects, keeping college costs low (e.g., graduating on time), and securing a competitive internship can help improve your potential return.',
                bold: false,
              },
            ],
            leftCardContent: {
              title: 'Example:',
              description: [
                {
                  text: 'If you invested $100, you’d end up with $101 to $199 over 14 years—your original $100 back, plus a little more in earned income.',
                  bold: false,
                },
              ],
            },
            rightCardContent: {
              title: 'What to watch for:',
              description: [
                {
                  text: 'This level is typical in moderate-paying careers, especially if college costs are higher or payback takes longer. You may need to budget more carefully or take longer to hit goals like paying off debt or saving for a major purchase.',
                  bold: false,
                },
              ],
            },
          },
          lowROI: {
            title: 'Low or Negative ROI',
            chipLabel: 'Below 0%',
            chipColor: 'Error/400',
            iconName: 'Hurricane05',
            cardDescription: [
              {
                text: 'You didn’t earn back what you spent—at least not within 14 years. That doesn’t mean your degree wasn’t valuable, but it didn’t deliver a financial return in the near term. To reduce risk, look to ',
                bold: false,
              },
              {
                text: 'lower cost of attendance',
                bold: true,
              },
              {
                text: ' by applying for financial aid, or focus on majors with durable job prospects. Even within lower-paying careers, building skills, taking internships, or getting certifications can lead to better job opportunities and long-term payoff.',
                bold: false,
              },
            ],
            leftCardContent: {
              title: 'Example:',
              description: [
                {
                  text: 'If you invested $100, you’d end up with less than $100—meaning you lost money over the initial 14 years.',
                  bold: false,
                },
              ],
            },
            rightCardContent: {
              title: 'Risks to consider:',
              description: [
                {
                  text: 'This can happen when students ',
                  bold: false,
                },
                {
                  text: 'borrow a lot, don’t complete their degree,',
                  bold: true,
                },
                {
                  text: ' or enter fields with ',
                  bold: false,
                },
                {
                  text: 'very low average salaries.',
                  bold: true,
                },
                {
                  text: ' It limits financial freedom—making it harder to save, invest, or avoid long-term debt.',
                  bold: false,
                },
              ],
            },
          },
        },

        yAxisLabel: 'Cumulative Return',
        xAxisLabel: 'Year',
        rankedAverageLegend: 'Ranked Average',
        rankedAverageTooltip:
          'The Ranked Average represents the average 14-year ROI of the top 50 colleges based on ROI performance. It reflects the typical financial return students can expect after accounting for tuition and opportunity costs. This figure serves as a benchmark for evaluating the long-term economic value of attending different institutions.',
        chipLabel: (total_roi: number, average_roi: number) => {
          if (total_roi > average_roi) {
            return `${Math.round(((total_roi - average_roi) / average_roi) * 100)}% higher than ranked average`;
          }
          if (total_roi < average_roi) {
            return `${Math.round(((average_roi - total_roi) / average_roi) * 100)}% lower than ranked average`;
          }

          return 'On par with ranked average';
        },
      },
    },
    nugget: {
      eventSubtext: 'Date:',
      opportunitySubtext: 'Deadline:',
      dialogNuggetActions: {
        bookmark: 'Bookmark',
        share: 'Share',
        copyLink: 'Copy Link',
        linkCopied: 'Link copied!',
        markDone: 'Mark as done',
        markComplete: 'Mark complete',
        explainFitScore: 'Explain my fit score',
      },
      internship: {
        notAvailable: 'N/A',
        askLubav: {
          amIAGoodFit: 'Am I a good fit?',
          increaseMyOdds: 'Increase my odds',
          similarRoles: 'Similar roles',
        },
        SECTION_TITLES: {
          quickLook: 'Quick Look',
          backrsAssessment: 'Backrs Assessment',
          applicationLink: 'Application Link',
        },
        QUICK_LOOK: {
          type: 'Type:',
          path: 'Path:',
          track: 'Track:',
          location: 'Location:',
          deadline: 'Deadline:',
          industry: 'Industry:',
        },
        BACKRS_ASSESSMENT: {
          growthPotential: 'Growth Potential:',
          compensation: 'Compensation:',
          intensity: 'Intensity:',
          gpaRequirement: 'Real GPA required:',
          achievementRequirement: 'Achievement required:',
          experienceRequirement: 'Experience:',
          technicalSkills: 'Technical skills:',
        },
      },
      scholarship: {
        SECTION_TITLES: {
          awardRange: 'Award Range',
          applicationDeadline: 'Application Deadline',
          previousYear: 'Previous Year',
          awardCategory: 'Award Category',
          description: 'Description',
          eligibilityRequirements: 'Eligibility Requirements & Program Restrictions',
          howToApply: 'How to Apply',
          applicationRequirements: 'Application Requirements',
          applicationSubmission: 'Application Submission',
          applicationDates: 'Application Dates',
          applicationFee: 'Application Fee',
          awardContact: 'Award Contact Information',
        },
        AWARD_INFO: {
          AWARD_RANGE: 'Award Range:',
          AWARD_TYPE: 'Award Type:',
          APPLICATION_DEADLINE: 'Application Deadline:',
          PREVIOUS_YEAR: 'Previous Year:',
          AWARDS: 'awards',
          AWARD_CATEGORY: 'Award Category:',
          DESCRIPTION: 'Description:',
        },
        ELIGIBILITY_REQUIREMENTS_STRINGS: {
          LEVEL_OF_STUDY_FRONT: 'Award for use during',
          LEVEL_OF_STUDY_END: 'years of study',
          INSTITUTION_TYPE: 'Students attending',
          LIMITED_HS: 'High school students can apply',
          TEST_SCORE: 'Test Score Requirement:',
          AGE: 'Age:',
          GENDER: 'Gender:',
          MARITAL_STATUS: 'Marital Status:',
          RACE_ETHNICITY: 'Race/Ethnicity:',
          DISABILITY_TYPE: 'Disability Type:',
          MILITARY_SERVICE: 'Military Service:',
          SEPT_ELEVEN_RESTRICTION: '9/11 survivors/descendants',
          HERITAGE: 'Heritage:',
          CITIZENSHIP: 'Citizenship:',
          RELIGIOUS_AFFILIATION: 'Denominations:',
          TALENT: 'Talent:',
          CLUB_MEMBERSHIP: 'Members of:',
          AREA_OF_STUDY: 'Field of study:',
          STATE_RESIDENCE: 'Residents of:',
          STATE_USAGE: 'Usable in:',
          COUNTY_RESIDENCE: 'County restrictions:',
          INSTITUTION: 'Restricted to:',
          CORP_AFFILIATION: 'Corporate affiliation:',
          EMPLOYMENT: 'Employment:',
        },
        HOW_TO_APPLY_STRINGS: {
          SUBMISSION_START: 'Submission Start Date:',
          SUBMISSION_DEADLINE: 'Submission Deadline:',
          CONTACT: 'Contact:',
        },
      },
      askLubav: {
        backrsProfile: 'Backrs profile',
        blueprint: 'Blueprint',
        networks: 'Networks',
        prosper: 'Prosper',
        errors: {
          COMING_SOON: 'Coming soon!',
          NOT_LOGGED_IN: 'You must be logged in to use this feature!',
          RESUME_REQUIRED: 'To use this feature, please upload your resume to your ',
          BLUEPRINT_REQUIRED:
            'You must have completed a blueprint to use this feature. You can do so by navigating to ',
          DEFAULT:
            "We're experiencing exceptionally high demand at the moment. Please check back in a few minutes! In the meantime, check out ",
        },
      },
      careerPath: {
        suggestedFits: {
          strong: 'Strong',
          medium: 'Medium',
          low: 'Low',
        },
        earlyCareerHires: 'Early-career hires per year',
        skilled: 'Skilled/Technical',
        professional: 'Professional',
        growth: 'Growth',
        ai_disruption: 'AI Disruption',
        insight: 'Insight',
        careerTrackDistribution: 'Career Track Distribution',
        semiSkilled: 'Semi-Skilled',
        tradesTechnical: 'Trades/Technical',
        middleTier: 'Middle-Tier Pro',
        upperTier: 'Upper-Tier Pro',
        topTier: 'Top-Tier Pro',
        opportunities: 'Opportunities',
        profiles: 'Profiles',
        employers: 'Employers',
        comingSoon: 'coming soon',
        threeRoles: (careerPath: string) => `3 ${careerPath.toLowerCase()} roles for me`,
        rolesByTrack: 'Job roles by track',
        compensationPotential: '$$ potential',
        requirements: 'How to succeed',
        aiDisruption: 'AI disruption',
        onTrack: 'Am I on track?',
      },
      textResponseDaysAgo: 'days ago',
    },
    tour: {
      showTour: 'Show Tour',
      leaveTour: 'Leave Tour',
    },
    headerCTA: {
      lifeReadiness: {
        title: 'How life-ready are you?',
        buttonText: 'Take the assessment',
      },
    },
  },
  buttonText: {
    letsGo: "Let's go!",
    login: 'Log In',
    viewMore: 'View More +',
    viewLess: 'View Less -',
    signIn: 'Sign in',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    finish: 'Finish',
    back: 'Back',
  },
} as const;
